const Select = {
  isComponent: el => el.tagName === 'SELECT',
  extend: 'select',
  model: {
    defaults: Object.assign({}, {
      tagName: 'select',
      draggable: true,
      droppable: true,
      copyable: true,
      attributes: {
        id: 'select'
      }
    })
  }
}

export default Select
